var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { View } from 'grommet-icons/es6/icons/View';

import { DropInput } from '../DropInput';

var PasswordInput = function (_Component) {
  _inherits(PasswordInput, _Component);

  function PasswordInput() {
    var _temp, _this, _ret;

    _classCallCheck(this, PasswordInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { showPassword: false }, _this.toggleView = function (e) {
      var showPassword = _this.state.showPassword;

      e.stopPropagation();
      _this.setState({ showPassword: !showPassword });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PasswordInput.prototype.render = function render() {
    var _props = this.props,
        viewIcon = _props.viewIcon,
        hideIcon = _props.hideIcon,
        a11yViewPassword = _props.a11yViewPassword,
        a11yHidePassword = _props.a11yHidePassword,
        rest = _objectWithoutProperties(_props, ['viewIcon', 'hideIcon', 'a11yViewPassword', 'a11yHidePassword']);

    var showPassword = this.state.showPassword;

    return React.createElement(DropInput, _extends({
      type: showPassword ? 'text' : 'password',
      widgets: [{
        'icon': showPassword ? hideIcon : viewIcon,
        'aria-label': showPassword ? a11yHidePassword : a11yViewPassword,
        'onClick': this.toggleView
      }]
    }, rest));
  };

  return PasswordInput;
}(Component);

PasswordInput.defaultProps = {
  viewIcon: React.createElement(View, null),
  hideIcon: React.createElement(View, null),
  a11yViewPassword: 'View password',
  a11yHidePassword: 'Hide password'
};


var PasswordInputDoc = void 0;
if (process.env.NODE_ENV !== 'production') {
  PasswordInputDoc = require('./doc').default(PasswordInput); // eslint-disable-line global-require
}

var PasswordInputWrapper = PasswordInputDoc || PasswordInput;

export { PasswordInputWrapper as PasswordInput };


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/PasswordInput/PasswordInput.js
// module id = 1192
// module chunks = 0